import { useMemo, useState } from 'react';

export const useJessica = () => {
  const [type, setWidgetType] = useState(
    (window as any).AiAgentsWebWidget.getComponentType({
      defaultComponentType: 'transcribe',
    })
  );

  const callbacks = useMemo(() => {
    return {
      onComponentType: (newType: any) => setWidgetType(newType),
    };
  }, []);

  return {
    type,
    callbacks: callbacks,
  };
};
